export const getFormattedDiscountPercentage = ({ discountedAmount, fullAmount, }) => `${Math.round((1 - discountedAmount / fullAmount) * 100)}%`;

// @zapier/upsells@5.0.1 (c64b11b3c)
